// extracted by mini-css-extract-plugin
export var gothic = "#7996a8";
export var lonchmara = "#0082d6";